export var setPrototypeOf = Object.setPrototypeOf || ({
  __proto__: []
} instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method

/**
 * setPrototypeOf polyfill using __proto__
 */

function setProtoOf(obj, proto) {
  // @ts-ignore
  obj.__proto__ = proto;
  return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */


function mixinProperties(obj, proto) {
  for (var prop in proto) {
    if (!obj.hasOwnProperty(prop)) {
      // @ts-ignore
      obj[prop] = proto[prop];
    }
  }

  return obj;
}